export enum WachterDivisions {
    Industrial = 3,
    Nationwide = 5,
    Corporate = 6,
    International = 7,
    Local_Business_Unit = 8,
    WTS = 12,
    Strategic_Projects = 13,
    Staffing = 14,
    Wachter_UK = 15,
    Wachter_Staffing = 16,
    Staffing_LBU = 25,
    Staffing_Nationwide = 26,
    Staffing_Industrial = 27,
    Staffing_Corporate = 28,
    Staffing_WTS = 29,

}